var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5142 31.6075C23.784 31.6075 26.4235 28.968 26.4235 25.6982C26.4235 22.4284 23.784 19.7889 20.5142 19.7889C17.2443 19.7889 14.6049 22.4284 14.6049 25.6982C14.6049 28.968 17.2443 31.6075 20.5142 31.6075ZM44.1514 19.7889H28.3932V33.5773H12.6351V15.8494H8.69556V45.3959H12.6351V39.4866H48.0909V45.3959H52.0304V27.668C52.0304 23.3148 48.5045 19.7889 44.1514 19.7889Z",
    fill: "#A8ADB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNights);
export default __webpack_public_path__ + "static/media/nights.a6a7add9430f28ac3ad9e6ac026da034.svg";
export { ForwardRef as ReactComponent };